import { cn } from "@/lib/utils";
import { formatBookLiquidity } from "@/lib/whale-watch/whale-watch-shared";

export function BookLiquidityLabel({
  amount,
  className,
}: {
  amount: number | null | undefined;
  className?: string;
}) {
  const text = formatBookLiquidity(amount);
  if (text === null) return null;
  return (
    <span className={cn("data-num text-[10px] leading-3 font-medium text-zinc-500", className)}>
      {text}
    </span>
  );
}
